import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-zinc-950 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1">
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <img
                src="/logo-small.png"
                alt="LeadGen AI"
                className="h-7 w-auto object-contain"
                loading="lazy"
              />
              <h2 className="text-base font-bold text-white">
                LeadGen<span className="text-blue-500"> AI</span>
              </h2>
            </Link>
            <p className="text-gray-400 text-sm font-medium mb-3">Business Lead Finder</p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Find business leads across the world in seconds. Export to CSV and Excel with emails and social links.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 tracking-wider text-sm uppercase">Product</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/search" className="hover:text-blue-400 transition-colors">Search</Link></li>
              <li><Link to="/pricing" className="hover:text-blue-400 transition-colors">Pricing</Link></li>
              <li><Link to="/dashboard" className="hover:text-blue-400 transition-colors">Dashboard</Link></li>
              <li><Link to="/login" className="hover:text-blue-400 transition-colors">Login</Link></li>
              <li><Link to="/signup" className="hover:text-blue-400 transition-colors">Sign Up</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 tracking-wider text-sm uppercase">Legal</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/privacy" className="hover:text-blue-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-blue-400 transition-colors">Terms of Service</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 tracking-wider text-sm uppercase">Help</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/faq" className="hover:text-blue-400 transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-blue-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>2025 LeadGen AI. All rights reserved.</p>
          <p className="mt-4 md:mt-0 flex items-center text-gray-400">
            Made with <span className="text-red-500 mx-1">love</span> in India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
